import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from "../../environments/environment";
import {FleetPolicy, FleetPolicyModel} from "../models/fleet-policy.model";
import {Observable} from 'rxjs';

@Injectable()
export class FleetPolicyDataSource {

  constructor(private http: HttpClient,) { }

  getFleetPolicies(): Observable<FleetPolicyModel[]> {
    return this.http.get<FleetPolicyModel[]>(environment.backendApi + 'api/FleetPolicy/getPolicies');
  }

  getFleetPolicyForCompany(companyId: string): Observable<FleetPolicyModel> {
    return this.http.get<FleetPolicyModel>(environment.backendApi + `api/Organization/${companyId}/GetFleetPolicy`);
  }

  updateFleetPolicyForCompany(companyId: string, output: FleetPolicy) {
    const body = output
    return this.http.put<any>(environment.backendApi + `api/Organization/${companyId}/UpdateFleetPolicy`, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    })
  }
}
